import {gql} from '@apollo/client';

export const GET_LEADERBOARD_SCHEMES = gql`
  query GetAllRewardSchemes(
    $page: Int
    $limit: Int
    $type: RewardSchemeType
    $isActive: Boolean
  ) {
    getAllRewardSchemes(
      page: $page
      limit: $limit
      type: $type
      isActive: $isActive
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithAllRewardSchemes {
        message
        pagination {
          total
        }
        data {
          rewardSchemes {
            createdAt
            title
            startDate
            isExpired
            operationConfig {
              cumulativeDurationValue
              cumulativeDurationUnit
              durationDescription
            }
            type
            id
            expirationDate
          }
        }
      }
    }
  }
`;

export const GET_LEADERBOARD_SCHEME_USERS = gql`
  query GetAdminLeaderboardEntries(
    $rewardSchemeId: ID!
    $mode: AppMode!
    $isEligibleForReward: Boolean
    $page: Int
    $limit: Int
  ) {
    getAdminLeaderboardEntries(
      rewardSchemeId: $rewardSchemeId
      mode: $mode
      isEligibleForReward: $isEligibleForReward
      page: $page
      limit: $limit
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on AdminLeaderboardEntriesResponse {
        pagination {
          total
        }
        rewardScheme {
          id
          title
          operationConfig {
            requireDabaPro
            minNumberOfTransactions
          }
        }
        entries {
          id
          rank
          roiChange
          currentROI
          startingROI
          currentPortfolioValue
          startingPortfolioValue
          reward {
            id
            status
            userReward {
              type
              ticker
              stockPrice
              rewardUnits
              cashValue
              cashValueInDisplayCurrency
              amount
              percentage
            }
          }
          currentTotalInvested
          startingTotalInvested
          portfolioPercentageChange
          isEligibleForReward
          cycleStartDate
          cycleEndDate
          calculatedAt
          user {
            id
            firstName
            lastName
            accountId
            proSubscription {
              hasProSubscription
            }
          }
          eligibilityDetails {
            numberOfTransactions
            requiredNumberOfTransactions
            hasDabaPro
            portfolioInvestedAmountInXOF
            requiredMinPortfolioInvestedAmountInXOF
            YTDWins
            maxNumberOfRewards
          }
        }
      }
    }
  }
`;

export const AUTHORIZE_REWARD = gql`
  mutation AdminUpdateUserRewardStatus(
    $status: RewardStatus!
    $adminUpdateUserRewardStatusId: ID!
  ) {
    adminUpdateUserRewardStatus(
      status: $status
      id: $adminUpdateUserRewardStatusId
    ) {
      ... on Error {
        message
        statusCode
      }
      ... on UserReward {
        id
      }
    }
  }
`;
